import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import oilProductionService from "../../services/oilProduction/oilProductionservice";
import { OilIntakeLogModel } from "../../models/oilProduction-model";

interface OilProductionSearchProps {
  setLoading: (loading: boolean) => void;
  onSearch: (data: OilIntakeLogModel[]) => void;
}

const OilProductionSearchDatatable2: React.FC<OilProductionSearchProps> = ({
  setLoading,
  onSearch,
}) => {
  const toast = useRef<Toast>(null);

  const [keyword, setKeyword] = useState("");
  const [masterData, setMasterData] = useState<OilIntakeLogModel[]>([]);
  const [oilseedOptions, setOilseedOptions] = useState<
    { label: string; value: number }[]
  >([]);
  const [selectedOilseed, setSelectedOilseed] = useState<number | null>(null);

  // Fetch all oil intake logs
  const fetchAllData = async () => {
    setLoading(true);
    try {
      const response = await oilProductionService.getAllOilIntakeLogs1();
        const result = [...response].sort((a, b) => Number(b.id) - Number(a.id));
      console.log("Fetched masterData:", result); // debug
      setMasterData(result);
      onSearch(result);
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch oil production logs.",
      });
      onSearch([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch oil intake logs on mount
  useEffect(() => {
    fetchAllData();
  }, []);

  // Fetch oilseed names for dropdown
  useEffect(() => {
    (async () => {
      try {
        const response = await oilProductionService.getAllOilSeedNames();
        const formatted = response.map((item: any) => ({
          label: item.name,
          value: item.id,
        }));
        setOilseedOptions(formatted);
      } catch (err) {
        console.error("Error fetching oilseeds:", err);
      }
    })();
  }, []);


const handleFilter = () => {
  debugger
  if (!masterData || masterData.length === 0) return;

  let filtered1 = [...masterData]; // start from records, not masterData

  // Keyword filter
  if (keyword.trim()) {
    const lowerKeyword = keyword.toLowerCase();
    filtered1 = filtered1.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(lowerKeyword)
      )
    );
  }

  // Oilseed filter
  if (selectedOilseed != null) {
    filtered1 = filtered1.filter(
      (item) => Number(item.oilSeedID) === Number(selectedOilseed)
    );
  }

  console.log("Filtered Data:", filtered1);
    onSearch(filtered1);
};

  // Reset filters
  const handleReset = () => {
    setKeyword("");
    setSelectedOilseed(null);
    onSearch(masterData);
  };

  return (
    <div className="card border-noround p-3 w-full">
      <Toast ref={toast} />

      <div className="grid align-items-center gap-3">
        {/* Keyword Search */}
          <div className="col-12 md:col-3">
          <div className="p-input-icon-left w-full">
            <i className="pi pi-search" />
            <InputText
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="Keyword Search"
              className="w-full"
            />
          </div>
        </div>

        {/* Oilseed Dropdown */}
        <div className="col-12 md:col-4">
          <Dropdown
            value={selectedOilseed}
            options={oilseedOptions}
            onChange={(e) => setSelectedOilseed(e.value)}
            placeholder="Select Oilseed"
            optionLabel="label"
            className="w-full"
            showClear
          />
        </div>
 {/* Filter Button */}
        <div className="col-12 md:col-2">
          <Button
            label="Filter"
             className="w-full"
            onClick={handleFilter}
          />
        </div>
        {/* Reset Button */}
        <div className="col-12 md:col-2 text-right">
          <Button
            label="Reset"
            className="w-full"
            severity="success"
            onClick={handleReset}
          />
        </div>
      </div>
    </div>
  );
};

export default OilProductionSearchDatatable2;
